<template>
  <div class="own-table">
    <table
      cellspacing="0"
      :style="bgcolor"
      style="width: 100%"
      class="table"
      cellpadding="0"
    >
      <tr>
        <th class="th" v-for="(item, index) in option.column" :key="index">
          {{ item.label }}
        </th>
      </tr>
      <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
        <td v-for="(context, i) in option.column" :key="i">
          {{ item[context.prop] }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    bgcolor: Object,
    tableData: Array,
    option: Object,
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.own-table {
  margin: 0 10px;
  margin-top: 37px;
  table {
    border-collapse: collapse; /* 合并边框 */
    border: 1.5px solid #ccc; /* 设置边框 */
  }
  th,
  td {
    border: 1.5px solid #ccc; /* 单元格边框 */
  }

  .table {
    border-color: #cccccc;
    border-collapse: collapse;
    .th {
      height: 1.074074rem;
      line-height: 1.074074rem;
      //   background-color: #393943;
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      //   border-top-left-radius: .185185rem;
      //   border-top-right-radius: .185185rem;
    }

    .list-tr {
      height: 1.074074rem;
      line-height: 1.074074rem;

      td {
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }
    }
    // .list-tr:nth-child(2n) {
    //   background-color: #33333b;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/detail/components/VipTable.vue